import React from "react";
import { useTranslation } from "react-i18next";

// Components
import Navbar from "../containers/Home/Navbar";
import SignupForm from "../containers/Signup/SignupForm";

//
import useAuth from "../utils/hooks/useAuth";

const Signup = () => {
  const { t } = useTranslation();

  useAuth({
    authRequired: false,
    redirectTo: "/editor",
  });

  return (
    <>
      <Navbar />
      <main className="landing-home content px-0 px-md-3">
        <div className="m-0 m-md-5">
          <div className="container-fluid bg-white bg-signup">
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="p-0 p-md-4">
                  <SignupForm />
                </div>
              </div>
              <div className="col-12 col-md-6 pt-5 d-none d-md-block">
                <div className="text-center marketing">
                  <h2>{t("signup.mainHeading")}</h2>
                  <p>{t("signup.text1")}</p>
                  <p className="heading">{t("signup.subHeading")}</p>
                  <p>{t("signup.text2")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Signup;
